import 'core-js/shim';
import 'regenerator-runtime/runtime'; // Sagas need this, if we don't have babel-polyfill as done in guest portal

import ravenRunner from 'utils/RavenRunner';

import useBluebird from 'utils/useBluebird';

import listenToUnhandledRejections from 'utils/listenToUnhandledRejections';

import 'html5-history-api';
import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory } from 'react-router';
// import FontFaceObserver from 'fontfaceobserver';
import configureRoutes from './routes';
import createStore from './stores/createStore';
import { setStore } from 'shared/stash';
import { configure as configureApi } from 'utils/api';
import buildRejectionHandler from 'shared/buildRejectionHandler';

import Root from 'shared/containers/Root';
import ReactModal from 'react-modal';
import { PortalConfigProvider } from 'shared/context/PortalConfig';

// import "@fontsource/inter.css"
import 'bulma/css/bulma.css';
import 'styles/agent_portal/app.scss';
import 'styles/tailwind.dist.css';

import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';
// import 'styles/fonts.scss';
import createIconLibrary from './createIconLibrary';

import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();

ravenRunner();

useBluebird(); // must occur after core-js/shim

listenToUnhandledRejections();

createIconLibrary();

const initialState = window.__INITIAL_STATE__;
const store = createStore(initialState, browserHistory);

setStore(store);
configureApi({
  defaultRejectionHandler: buildRejectionHandler(
    store.dispatch,
    browserHistory
  ),
});

const routes = configureRoutes(store);

ReactModal.setAppElement('#root');

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <PortalConfigProvider config={{ apiPrefix: '/agent_portal/api' }}>
      <Root history={browserHistory} store={store} routes={routes} />
    </PortalConfigProvider>
  </QueryClientProvider>,
  document.getElementById('root')
);

// Font Loading Observer Setup
// const proximaNova400 = new FontFaceObserver('proxima_novaregular');
// const proximaNova600 = new FontFaceObserver('proxima_novasemibold');
// const proximaNova700 = new FontFaceObserver('proxima_novabold');

// setTimeout(() => {
//   Promise.all([
//     proximaNova400.load(),
//     proximaNova600.load(),
//     proximaNova700.load(),
//   ]).then(
//     () => {
//       window.document.documentElement.className += ' fonts-loaded';
//     },
//     (error) => {
//       console.log(error);
//     }
//   ); // eslint-disable-line
// }, 1);
